import { ENUM_DIGITAL_SIGNATURE_AUTH } from "../types";

export const DIGITAL_AUTH_TABS_LIST = [
  {
    name: "registration",
    type: ENUM_DIGITAL_SIGNATURE_AUTH.REGISTRATION,
  },
  {
    name: "login",
    type: ENUM_DIGITAL_SIGNATURE_AUTH.LOGIN,
  },
];
